/**
 * CommandHighlightMirror — reports cmdk's highlighted (keyboard-selected)
 * item value to its parent.
 *
 * cmdk moves its own highlight (first item on open, first match on each
 * search change) without always going through `onValueChange`, so a parent
 * that needs to know where the highlight actually sits reads it from the
 * command store instead. Rendered inside a `<Command>`; renders nothing.
 */

import { useEffect } from "react";
import { useCommandState } from "cmdk";

interface CommandHighlightMirrorProps {
  onHighlightChange: (value: string) => void;
}

export function CommandHighlightMirror({
  onHighlightChange,
}: CommandHighlightMirrorProps) {
  const value = useCommandState((state) => state.value);
  useEffect(() => {
    onHighlightChange(value);
  }, [value, onHighlightChange]);
  return null;
}
